import React from 'react';
import routes from '../constants/routes.json';
import { AnyType, Routine } from '~/types';
import { DefaultRunningAnyTile } from './defaultUIComponents';
import { useRunningAnys } from '~/api/JobApi';
import { useEmployeeId } from '~/state/auth';
import { isRunningRoutine } from '~/utils/runningAny';
import { useResumeRoutine, useStartRoutine } from '~/api/RoutineApi';
import { useNavigate } from 'react-router';

type RoutineProps = {
  routine: Routine;
  isStartable?: boolean;
};

const RoutineTile: React.FC<RoutineProps> = ({ routine, isStartable }) => {
  const navigate = useNavigate();
  const employeeId = useEmployeeId();

  const { data: runningRoutine } = useRunningAnys({
    employeeId,
    select: (ra) =>
      ra.find((rr) => isRunningRoutine(rr) && rr.routine.id == routine.id),
  });

  const onSuccess = () => {
    return navigate(startRoutineRoute);
  };

  const { mutate: startRoutine } = useStartRoutine({ onSuccess });
  const { mutate: resumeRoutine } = useResumeRoutine({ onSuccess });
  const startRoutineRoute = routes.RUN_ROUTINE.replace(':routine', routine.id);

  const runRoutineOnClick = () => {
    if (runningRoutine?.status === 'R') {
      return void navigate(startRoutineRoute);
    }
    if (runningRoutine) {
      return resumeRoutine({ runningRoutineId: Number(runningRoutine.id) });
    }
    startRoutine({ routineId: Number(routine.id) });
  };

  return (
    <DefaultRunningAnyTile
      anyType={AnyType.routine}
      name={routine.name}
      description={routine.description}
      runRunningAny={runRoutineOnClick}
      isStartable={isStartable}
    />
  );
};

export default RoutineTile;
